import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";

const ModalEdit = ({
  isOpen,
  toggle,
  title,
  codigoDescripcion,
  descripcionAsosiadaId,
  updateTable,
  id,
  token,
}) => {
  const [descripcion, setDescripcion] = useState([]);
  const [codigo, setCodigo] = useState("");
  const [selectedDescripcion, setSelectedDescripcion] = useState("");
  const [selectedDescripcion2, setSelectedDescripcion2] = useState("");
  const [, setFormMode] = useState("none");
  const modalRef = useRef(null);

  useEffect(() => {
    setCodigo(codigoDescripcion)
  }, [codigoDescripcion]);

  useEffect(() => {
    if (token) {
      axios
        .get("/descripcion", { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          setDescripcion(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [token]);

  const descripcionOptions = descripcion.map((option) => ({
    value: option.id,
    label: option.Texto ?? option.Texto,
  }));

  const handleCodigoDescripcionChange = (event) => {
    setCodigo(event.target.value);
  };


  const handleDescripcionChange = (selectedOption) => {
    setSelectedDescripcion2(selectedOption.value);
    setSelectedDescripcion(
      descripcionOptions.find((option) => option.value === selectedOption.value)
    );
  };

  const handleEditSubmit = (event) => {
    event.preventDefault();
    axios
      .put(
        `/codigoDescripcion/${id}`,
        {
          CodigoServicio: codigo,
          TipoDescripcionId: parseInt(selectedDescripcion2)
            ? parseInt(selectedDescripcion2)
            : parseInt(descripcionAsosiadaId),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Actualizado!",
          text: "el codigo a sido actualizado con exito.",
          showCloseButton: true,
        }).then(() => {
          updateTable();
          toggle();
          setCodigo("");
          setSelectedDescripcion("");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "el codigo no se pudo actualizar",
          showCloseButton: true,
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>codigo descripcion:</label>
          <input
            className="form-control"
            name="codgioDescripcion"
            type="text"
            value={codigo}
            onChange={handleCodigoDescripcionChange}
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="servicioId">Descripción asociada:</label>
          <Select
            value={
              selectedDescripcion
                ? selectedDescripcion
                : descripcionOptions.find((option) => option.value === descripcionAsosiadaId)
            }
            onChange={handleDescripcionChange}
            options={descripcionOptions}
          ></Select>
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleEditSubmit} color="primary" otype="submit">
          Guardar
        </Button>
        <Button color="danger" onClick={() => setFormMode("none")}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalEdit;
